import { DataBean } from "../DataBean";

export class ProcessStep extends DataBean {

    public async getProcessStepCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessFlow", "java.util.List_getProcessStepCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

}